import React from "react";
import Library from "./Library";

const Icon = (props) => <Library name="fa-solid fa-circle-minus" {...props} />;

Icon.displayName = "Icon.Error";
export default Icon;
